import {
    JUSHITA_OMS_BASE_URL,
    PDD_OMS_BASE_URL,
    JD_OMS_BASE_URL,
    ALIYUN_OMS_BASE_URL,
    DOUDIAN_OMS_BASE_URL,
} from "@/config";
import axios from "axios";
import tbPCAxiosAdapter from "@qn/services/http/tbAxiosAdapter";

const adapter = import.meta.env.VITE_IS_QN ? tbPCAxiosAdapter : undefined;

// withCredentials = true 是因为需要将前端的cookies传会后端，有些平台（淘宝、京东、拼多多）需要在前端对接安全日志JS，安全JS会在cookies中插入一些数据
// 一些订单操作需要在后端接收这些cookies，然后回传给平台, 如淘宝御城河：
// https://eco-doc.alibaba.com/docs/doc.htm?treeId=227&articleId=105449&docType=1

// 聚石塔（阿里、淘宝）
const jushitaAxios = axios.create({
    baseURL: JUSHITA_OMS_BASE_URL,
    timeout: 55000,
    withCredentials: true,
    adapter,
});

// 拼多多
const pddAxios = axios.create({
    baseURL: PDD_OMS_BASE_URL,
    timeout: 55000,
    withCredentials: true,
    adapter,
});

// 京东
const jdAxios = axios.create({
    baseURL: JD_OMS_BASE_URL,
    timeout: 55000,
    withCredentials: true,
    adapter,
});

// 阿里云（其他平台及手工订单）
const aliyunAxios = axios.create({
    baseURL: ALIYUN_OMS_BASE_URL,
    timeout: 55000,
    withCredentials: true,
    adapter,
});

// 抖店
const doudianAxios = axios.create({
    baseURL: DOUDIAN_OMS_BASE_URL,
    timeout: 55000,
    withCredentials: true,
    adapter,
});

export { jushitaAxios, pddAxios, jdAxios, aliyunAxios, doudianAxios };
